import React, { Component } from 'react';
import { Link } from 'react-router';
import _ from 'lodash';
import styles from './overlay.scss';
import CSSModules from 'react-css-modules';
import Slider from '../Object/Slider';
import Icon from '../shared/Icon';
import {getCurrentLanguage} from '../../localData';
import { isMobile, isTablet, getActiveSlide } from '../../common';


class Overlay extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showCaptions: true,
            activeSlide: 0,
        };
    }

    componentDidMount() {
        const activeSlide = getActiveSlide();
        if (activeSlide) {
            this.setState({ activeSlide });
        }
    }

    toggleCaptions = () => {
        if (isMobile() || isTablet()) {
            this.setState({
                showCaptions: !this.state.showCaptions
            });
        } else {
        }
    };

    trackActiveSlide = (idx) => {
        this.setState({ activeSlide: idx });
    };

    render() {
        const backUrl = `${getCurrentLanguage()}/object/${this.props.params.id}`;
        const { store, history } = this.props;
        const obj = this.props.store.object;
        return (
            <div className="overlay" styleName="overlay">
                {
                    obj.ObjMultimediaCount > 0 &&
                    <Slider
                        store={ store }
                        object={ obj }
                        history={ history }
                        multimediaWidths={JSON.parse(this.props.store.object.ObjMultimediaWidths)}
                        multimediaCount={obj.ObjMultimediaCount}
                        onClick={ this.toggleCaptions }
                        showCaptions={ this.state.showCaptions }
                        isOverlay={true}
                        activeSlide={this.state.activeSlide}
                        trackActiveSlide={this.trackActiveSlide}
                    />
                }
                <Link styleName="button-close" to={{ pathname: backUrl, query: { target: 'slider', activeSlide: this.state.activeSlide }}}>
                    <Icon icon="Vitra_Close.svg" />
                </Link>
            </div>
        )
    }
}

export default CSSModules(Overlay, styles);


// WEBPACK FOOTER //
// ./app/components/Overlay/Overlay.jsx